<div class="align-left" *ngIf="!!field">
    <span class="wrapped-text label-grid">{{ fieldSchema.label }}</span>
    <lsq-smart-truncate
        class="wrapped-text label-content-grid"
        [class.wrapped-text-admin]="adminMode"
        [value]="this.parseFieldValue()"
        [popoverValue]="field.fieldValue"
    ></lsq-smart-truncate>
</div>
